// API Base URL - must be set via REACT_APP_API_BASE_URL environment variable during build
// For production, ensure REACT_APP_API_BASE_URL is set in your build environment
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// const BASE_URL = "http://localhost:8000";

if (!BASE_URL) {
  console.error('REACT_APP_API_BASE_URL is not set! API calls will fail.');
  // Optionally throw an error in production builds
  // throw new Error('REACT_APP_API_BASE_URL environment variable is required');
}

export const API_URL = BASE_URL;
// export const API_URL = "http://127.0.0.1:8000";